module.exports = __webpack_public_path__ + "img/02.55418263.png";